module.exports = __webpack_public_path__ + "img/87.a0ca6939.jpg";